<script>
	export let label = undefined;
	export let name;
	export let value = undefined;
	export let className = '';
	export let errors = [];
	export let inputClasses = '';

	// eslint-disable-next-line no-unused-vars
	$: props = (({ label, name, value, className, inputClasses, errors, ...rest }) => rest)($$props);
</script>

<div class={className}>
	{#if label}
		<label class="form-label" for={name}>{label}</label>
	{/if}

	<input
		id={name}
		{name}
		bind:value
		on:change
		on:input
		on:keyup
		on:keydown
		on:focus
		{...props}
		class={'form-input focus:outline-none ' + inputClasses}
		class:error={errors && errors.length}
	/>

	{#if errors && errors.length}
		<div class="form-error">{errors[0]}</div>
	{/if}
</div>
